import Notifications from 'react-notification-system-redux';
import { connect } from 'react-redux';

import addAbilityToOpenModal from '../../../../utilities/modalHOC';
import {
  getGeneralRolesPermissions,
  getRolesPermissions,
  getUser,
} from '../../../Login/selectors';
import {
  onShowQuestionDetails,
  onShowQuestionOverview,
  reorderAssignmentsLocal,
  setLoadingCreateGPTquestion,
  setSelectedWriter,
  toggleQuestionOverview,
} from '../../actions';
import {
  loadAllWriters,
  onDeleteAssignment,
  onEditAssignment,
  submitQuestionsGPT,
} from '../../actionsSagas';
import {
  getIsQuestionOverview,
  getLoadingCreateQuestions,
  getSelectedAdmin,
  getSelectedAssignment,
  getSelectedWriter,
  getSummary,
  getWriters,
} from '../../selectors';
import AssignmentsByWriter from './AssignmentsByWriter';

const mapStateToProps = (state, ownProps) => ({
  writers: getWriters(state),
  user: getUser(state),
  selectedAdmin: getSelectedAdmin(state),
  selectedWriter: getSelectedWriter(state),
  isQuestionOverview: getIsQuestionOverview(state),
  selectedAssignment: getSelectedAssignment(state),
  generalRolesPermissions: getGeneralRolesPermissions(state),
  rolesPermissions: getRolesPermissions(state),
  summary: getSummary(state),
  loadingCreateGPTquestions: getLoadingCreateQuestions(state),
});

const mapDispatchToProps = (dispatch) => ({
  loadAllWriters: (selectedWriterEmail) =>
    dispatch(loadAllWriters(selectedWriterEmail)),
  onEditAssignment: (assignment, isEditStatus, rejected) => {
    dispatch(onEditAssignment(assignment, isEditStatus, rejected));
  },
  onQuestionDetails: (assignment, rate) => {
    dispatch(onShowQuestionDetails(assignment, rate));
    dispatch(toggleQuestionOverview(true));
  },
  toggleQuestionOverview: (value) => {
    dispatch(toggleQuestionOverview(value));
  },
  onQuestionOverview: (assignment) => {
    dispatch(onShowQuestionOverview(assignment));
    dispatch(toggleQuestionOverview(true));
  },
  onDelete: (assignment, writerId) => {
    dispatch(onDeleteAssignment(assignment, writerId));
  },
  selectWriter: (writer) => {
    dispatch(setSelectedWriter(writer));
  },
  onSubmitQuestions: (fields, assignment) => {
    dispatch(submitQuestionsGPT(fields, assignment));
  },
  setLoadingCreateGPTquestion: (value) => {
    dispatch(setLoadingCreateGPTquestion(value));
  },
  reorderAssignmentsLocal: (reorderedAssignments) => {
    dispatch(reorderAssignmentsLocal(reorderedAssignments));
  },
  showWarning: (title, message) => {
    dispatch(Notifications.warning({ title, message }, 'failure'));
  },
});

const AssignmentsByWriterContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(AssignmentsByWriter);

export default addAbilityToOpenModal(AssignmentsByWriterContainer);
